import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/Auth/AuthShell";
import { PATHS } from "../routes/paths";
import api from "../services/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    setIsSubmitting(true);

    try {
      const response = await api.post("/auth/forgot-password", { email });
      setMessage(response.data?.message || "Se o e-mail estiver cadastrado, enviaremos instrucoes.");
    } catch (requestError) {
      setError(requestError.response?.data?.error || "Nao foi possivel solicitar a recuperacao.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell title="Insira o e-mail cadastrado" compact>
      <form className="auth-form auth-form--compact" onSubmit={handleSubmit}>
        <label className="auth-form__field">
          <input
            className="auth-form__input"
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />
        </label>

        <p className="auth-form__helper">
          Você receberá um link para redefinição
          <br />
          de senha no e-mail cadastrado
        </p>

        {message && <p className="auth-form__message auth-form__message--success">{message}</p>}
        {error && <p className="auth-form__message auth-form__message--error">{error}</p>}

        <div className="auth-form__actions">
          <button
            className="auth-form__button auth-form__button--compact"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Enviando..." : "Enviar"}
          </button>

          <Link
            className="auth-form__button auth-form__button--compact auth-form__button--secondary"
            to={PATHS.login}
          >
            Cancelar
          </Link>
        </div>
      </form>
    </AuthShell>
  );
};

export default ForgotPassword;
